// actions/employee-onboarding/add.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function addHasErrored(bool) {
  return {
    type: 'ONBOARDING_ADD_HAS_ERRORED',
    hasErrored: bool
  };
}

export function addIsLoading(bool) {
  return {
    type: 'ONBOARDING_ADD_IS_LOADING',
    isLoading: bool
  };
}

export function addFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_ADD_FETCH_DATA_SUCCESS',
    data
  };
}

export function addFetchData(host, params) {
  return (dispatch) => {
    if (params == null) {
      dispatch(addIsLoading(false));
      dispatch(addHasErrored(false));
      dispatch(addFetchDataSuccess([]));
    }
    else {
      dispatch(addIsLoading(true));
      dispatch(addHasErrored(false));
      fetch(host + 'admin/add', {
        method: 'post',
        body: JSON.stringify(params),
        headers: attachAuth()
      }).then(promise => {
          if (!promise.ok) {
            throw Error(promise.statusText);
          }
          
          promise.json()
            .then(result => {
              dispatch(addFetchDataSuccess(result));
              dispatch(addHasErrored(false));
              dispatch(addIsLoading(false));
              PubSub.publish('employee.add.action', result);
            })
            .catch((ex) => {
              console.log(ex);
              dispatch(addHasErrored(true));
              dispatch(addIsLoading(false));
            });
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(addHasErrored(true));
        dispatch(addIsLoading(false));
      });
    }
  };
}